import { ShippingOption } from "@Types/addresses";
import { CheerzApiShippingOption } from "@Types/api/addresses";
import { convertPriceFromApiToContent, convertPriceFromContentToApi } from "./price";

export const convertShippingOptionFromContentToApi = (
  contentOption: ShippingOption
): CheerzApiShippingOption => {
  return {
    available: contentOption.available !== true ? false : true,
    delivery_dates: contentOption.deliveryDates ? contentOption.deliveryDates : null,
    price: contentOption.price ? convertPriceFromContentToApi(contentOption.price) : null,
    selected: contentOption.selected,
  };
};

export const convertShippingOptionFromApiToContent = (
  jsonOption: CheerzApiShippingOption
): ShippingOption => {
  // hack on available because dev and staging set normal delivery to null while available
  return {
    available:
      jsonOption.available === true
        ? true
        : jsonOption.available === null && jsonOption.selected === true
        ? true
        : false,
    deliveryDates: jsonOption.delivery_dates ? jsonOption.delivery_dates : undefined,
    price: jsonOption.price ? convertPriceFromApiToContent(jsonOption.price) : undefined,
    selected: jsonOption.selected,
  };
};
